/*
 * Copyright (c) 2022. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { type APIPermissions, AppSystemPermissions, type RoutePath } from '@poweralpha/common';
import Home from './home/Home';
import { lazy } from './lazy';
import Notifications from './notifications/Notifications';
import { Routes } from './react-components/navigate/routes';
import PageContent from './react-components/PageContent';
import SystemIssueAdmin from './system-issues/SystemIssueAdmin';

const ProjectsEntry = lazy(() => import('./project/ProjectsEntry.js'));
const OpportunitiesEntry = lazy(() => import('./bid-requests/OpportunitiesEntry.js'));
const BidRequestsEntry = lazy(() => import('./bid-requests/BidRequestsEntry.js'));

const pathElementMap: Partial<Record<RoutePath, React.ReactNode>> = {
  '*': (
    <PageContent>
      <Home />
    </PageContent>
  ),
  '/projects/*': <ProjectsEntry />,
  '/opportunities/*': <OpportunitiesEntry />,
  '/bid-requests/*': <BidRequestsEntry />,
  '/notifications': (
    <PageContent>
      <Notifications />
    </PageContent>
  ),
  '/admin/system-issues': (
    <PageContent disableGutters>
      <SystemIssueAdmin />
    </PageContent>
  ),
};

const permissionFilter: (
  key: RoutePath,
  permissions: Array<APIPermissions> | undefined,
) => boolean | undefined = (key, permissions) => {
  if (key === '/admin/system-issues') {
    return permissions?.includes(AppSystemPermissions.SYSTEM_ADMIN) ?? false;
  }

  return true;
};

function HomePage() {
  return <Routes pathElementMap={pathElementMap} permissionFilter={permissionFilter} />;
}

export default HomePage;
